import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { SignInComponent } from 'src/app/demo/components/staff-management/staff-profile/sign-in/sign-in.component';
import { AbsentStudentsComponent } from 'src/app/demo/components/student-sign-in/daily-absent-students/absent-students.component';
import { SignOutComponent } from 'src/app/demo/components/staff-management/staff-profile/sign-out/sign-out.component';
import { SigninStudentComponent } from 'src/app/demo/components/student-sign-in/mark-attendance/signin-student/signin-student.component';
import { SignoutStudentComponent } from 'src/app/demo/components/student-sign-in/mark-attendance/signout-student/signout-student.component';
import { TransferStudentComponent } from 'src/app/demo/components/student-sign-in/mark-attendance/transfer-student/transfer-student.component';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { OperationService } from 'src/app/demo/service/operation.service';
import { MarkTransferComponent } from 'src/app/demo/components/staff-management/staff-attendance/mark-transfer/mark-transfer.component';
import { StaffMarkAbsentComponent } from 'src/app/demo/components/staff-management/view-attendance/staff-mark-absent/staff-mark-absent.component';
import { MarkAbsentStudComponent } from 'src/app/demo/components/student-sign-in/mark-absent-stud/mark-absent-stud.component';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { Common } from 'src/app/demo/utils/common';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quick-panel-attendance',
  templateUrl: './quick-panel-attendance.component.html',
  styleUrls: ['./quick-panel-attendance.component.scss'],
})
export class QuickPanelAttendanceComponent {
  @Input() attendanceData: any;
  @Output() closeButnClick = new EventEmitter<boolean>();
  ref: any;
  @Output() staffAttendanceRefresh = new EventEmitter<boolean>();
  @Output() studentAttendanceRefresh = new EventEmitter<boolean>();
  @Input() isVisible: boolean = false;
  openExpected: boolean = false;
  unexpectedStudentNames: any;
  attendanceObj: any;
  studentIds: any;
  userData: any;
  toDate !: string;
  fromDate !: string;
  presentStaffIds: any[] = [];
  presentStudentIds: any[] = [];
  constructor(
    public dialogService: DialogService,
    private messageService: MessageService,
    private operationService: OperationService,
    private storage: WebStorage,
    private lookupService: LookupService,
    private router: Router
  ) { }
  ngOnInit() {
    this.userData = this.storage.getUserData();
    this.fromDate = Common.momentTimeZoneDate(new Date);
    this.toDate = Common.momentTimeZoneDate(new Date);
    const queryParamStaff = {
      'date.greaterThanOrEqual': Common.getUtcStartOfDay(this.fromDate),
      'date.lessThanOrEqual': Common.getUtcEndOfDay(this.toDate)
    };
    Common.removeEmptyFields(queryParamStaff);
    this.lookupService
      .getPresentStaffId(queryParamStaff)
      .subscribe((res: HttpResponse<any[]>) => {
        let temp: any[] = [];
        this.presentStaffIds = res.body ? res.body : temp;
      });
      const queryParamStud = {
        'schoolId.equals' : this.userData.schoolId,
        'date.greaterThanOrEqual': Common.getUtcStartOfDay(this.fromDate),
        'date.lessThanOrEqual': Common.getUtcEndOfDay(this.toDate),
        'studentId.specified': true,
      };
      Common.removeEmptyFields(queryParamStud);
    this.lookupService
      .queryAttendance(queryParamStud)
      .subscribe((res: HttpResponse<any[]>) => {
        let temp: any[] = [];
        this.presentStudentIds = res.body ? res.body.map((item : AttendanceDTO)=> item.studentId) : temp;
        
      });
  }
  onClose() {
    this.closeButnClick.emit(false);
  }
  openSignIn() {
    const screenWidth = window.innerWidth; // Get the screen width
    let dialogWidth = '70%'; // Default width for larger screens
    if (screenWidth <= 768) {
      dialogWidth = '90%'; // For mobile devices
    } else if (screenWidth <= 1024) {
      dialogWidth = '40%'; // For tablets
    }

    if (this.attendanceData?.formModule == 'Student') {
      // const dialogData = this.loggedStaff;
      const dialogData = '';
      this.ref = this.dialogService.open(SigninStudentComponent, {
        data: { staff: dialogData, isDashboard: true, activeIndex: 0, fromOverView: false, },
        header: 'Sign-In',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'student-sign-in-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res.openExpected == true) {
          this.openExpected = true;
          this.unexpectedStudentNames = res.unexpectedStudentNames;
          this.attendanceObj = res.attendanceData;
          this.studentIds = res.studentIds;
        }
        else {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.studentAttendanceRefresh.emit(true);
        }
      });
    } else if (this.attendanceData?.formModule == 'Staff') {
      const dialogData = '';
      this.ref = this.dialogService.open(SignInComponent, {
        data: {
          staff: dialogData,
          formName: 'Staff_SignIn',
          isDashboard: true,
          activeIndex: 0,
          fromOverView: false,
          // presentStaffIds: this.presentStaffIds 
        },
        header: 'Sign-In',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'student-sign-in-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {        
          if (res.openExpected == true) {
            this.unexpectedStudentNames = res.unexpectedStudentNames;
            this.attendanceObj = res.attendanceData;
            this.studentIds = res.selectedStaffId;
            this.openExpected = true;
        } else {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.staffAttendanceRefresh.emit(true);
        }
      });
    }
  }

  openSignOut() {
    const screenWidth = window.innerWidth; // Get the screen width
    let dialogWidth = '70%'; // Default width for larger screens
    if (screenWidth <= 768) {
      dialogWidth = '90%'; // For mobile devices
    } else if (screenWidth <= 1024) {
      dialogWidth = '40%'; // For tablets
    }

    if (this.attendanceData?.formModule == 'Student') {
      // const dialogData = this.loggedStaff;
      const dialogData = '';
      this.ref = this.dialogService.open(SignoutStudentComponent, {
        data: { staff: dialogData, isDashboard: true, activeIndex: 0, fromOverView: false },
        header: 'Sign-Out',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'student-sign-out-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res != undefined) {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.studentAttendanceRefresh.emit(true);
        }
      });
    } else if (this.attendanceData?.formModule == 'Staff') {
      const dialogData = '';
      this.ref = this.dialogService.open(SignOutComponent, {
        data: {
          staff: dialogData,
          formName: 'Staff_SignIn',
          isDashboard: true,
          activeIndex: 0,
          fromOverView: false
        },
        header: 'Sign-Out',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'staff-sign-out-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res != undefined) {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.staffAttendanceRefresh.emit(true);
        }
      });
    }
  }
  openTransfer() {
    const screenWidth = window.innerWidth; // Get the screen width
    let dialogWidth = '70%'; // Default width for larger screens
    if (screenWidth <= 768) {
      dialogWidth = '90%'; // For mobile devices
    } else if (screenWidth <= 1024) {
      dialogWidth = '40%'; // For tablets
    }

    if (this.attendanceData?.formModule == 'Student') {
      // const dialogData = this.loggedStaff;
      const dialogData = '';
      this.ref = this.dialogService.open(TransferStudentComponent, {
        data: { staff: dialogData, isDashboard: true, activeIndex: 0, fromOverView: false },
        header: 'Transfer',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'student-transfer-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res != undefined) {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.studentAttendanceRefresh.emit(true);
        }
      });
    } else if (this.attendanceData?.formModule == 'Staff') {
      const dialogData = '';
      this.ref = this.dialogService.open(MarkTransferComponent, {
        data: {
          staff: dialogData,
          formName: 'Staff_SignIn',
          isDashboard: true,
          activeIndex: 0,
          fromOverView: false
        },
        header: 'Transfer',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'staff-transfer-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res != undefined) {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.staffAttendanceRefresh.emit(true);
        }
      });
    }
  }
  openAbsent() {
    const screenWidth = window.innerWidth; // Get the screen width
    let dialogWidth = '70%'; // Default width for larger screens
    if (screenWidth <= 768) {
      dialogWidth = '90%'; // For mobile devices
    } else if (screenWidth <= 1024) {
      dialogWidth = '40%'; // For tablets
    }


    if (this.attendanceData?.formModule == 'Student') {
      // const dialogData = this.loggedStaff;
      const dialogData = '';
      this.ref = this.dialogService.open(MarkAbsentStudComponent, {
        data: { staff: dialogData, isDashboard: true, activeIndex: 0, fromOverView: false, presentStudentIds: this.presentStudentIds },
        header: 'Mark Absent',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'student-absent-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res != undefined) {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          setTimeout(() => {
            this.studentAttendanceRefresh.emit(true);
            this.router.navigateByUrl('/student-Sign-In/absentStudent');
          }, 1000);
        }
      });
    } else if (this.attendanceData?.formModule == 'Staff') {
      // const dialogData = this.loggedStaff;
      const dialogData = '';
      this.ref = this.dialogService.open(StaffMarkAbsentComponent, {
        data: { staff: dialogData, isDashboard: true, activeIndex: 0, fromOverView: false, presentStaffIds: this.presentStaffIds },
        header: 'Mark Absent',
        width: dialogWidth,
        contentStyle: {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          'max-height': '80vh', 
      },
        styleClass: 'staff-absent-dialog',
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe((res: any) => {
        if (res != undefined) {
          this.messageService.add({
            severity: res.severity,
            summary: res.summary,
            detail: res.detail,
            life: res.life,
          });
          this.onClose();
          this.staffAttendanceRefresh.emit(true);
          setTimeout(() => {
          this.router.navigateByUrl('/staff/viewAttendance/absent-view');
          },1000);
        }
      });
    }
  }
  buttonDisabled: boolean = false;
  onSaveAttendance() {
    this.buttonDisabled = true;
    this.operationService
      .createAttendanceAll(this.attendanceObj, this.studentIds)
      .subscribe(
        (res: HttpResponse<AttendanceDTO>) => {
          const messages = {
            severity: 'success',
            life: 3000,
            summary: 'Success',
            detail: `${this.attendanceObj.hasStudentId == true ? 'Student' : 'Staff'} Signed In successfully.`,
          };
          this.ref.close(messages);
          this.openExpected = false;
          this.studentAttendanceRefresh.emit(true);
          this.buttonDisabled = false;
        },
        (error) => {
          this.messageService.add({
            severity: 'error',
            life: 3000,
            summary: 'Error',
            detail: error.error.title,
          });
          this.buttonDisabled = false;
        }
      );
  }
}
